var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor-steps-block"},[_c('steps',{attrs:{"current":_vm.step,"direction":"vertical"}},_vm._l((_vm.steps),function(step){return _c('step',{key:step.index,attrs:{"title":step.title,"content":step.content},nativeOn:{"click":function($event){return _vm.changeStep(step.index)}}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }